import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import Breadcrumbs from '../../../components/UI/Breadcrumbs';
import ButtonUI from '../../../components/UI/ButtonUI';
import { ScannerCode } from '../../../components/UI/ComponentsUI';
import InputUI from '../../../components/UI/InputUI';
import Select from '../../../components/UI/Select';
import AreaService from '../../../services/AreaService';
import ConfigurationService from '../../../services/ConfigurationService';
import DeliveryService from '../../../services/DeliveryService';
import LinePickingService from '../../../services/LinePickingService';
import { getVision } from '../../../services/auth';
import { ENUMS, VISIONS } from '../../../utils/constants';
import { onValueChange } from '../../../utils/handleChangeHooks';
import { isNullOrEmpty, showMessageToast, showMessageToastCustom, translate } from '../../../utils/util';

const AreaPdu = (props) => {
    const [insert, setInsert] = useState(true);
    const [pduList, setPduList] = useState([]);
    const [model, setModel] = useState({
        area: '',
    });

    useEffect(() => {
        if (props.area !== undefined) {
            model.area = props.area;
            setModel({ ...model });
        }
        props.getAreas(getVision(), {
            PlantId: getVision().split('-')[0]
        }, {
            PageSize: ENUMS.ePagination.PageSize.value
        });
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!isNullOrEmpty(model.area)) {
            props.getAreaPdu({
                areaId: model.area,
            }, (result) => {
                if (result && result.length > 0) {
                    setInsert(false);
                    setPduList(result);
                } else {
                    setInsert(true);
                }
            });
        }
        // eslint-disable-next-line
    }, [model.area]);

    const onChange = (event) => {
        onValueChange(event, model, setModel);
    };

    const cancel = () => {
        props.history.push({ pathname: '../config' });
    }

    const handleFormKeyDown = (e) => {
        if (e.key === 'Enter') {
            addPdu(document.getElementById('pdu').value);
        }
    }

    const submit = () => {
        if (isNullOrEmpty(model.area)) {
            return showMessageToast({ html: translate('Informe uma area'), classes: 'red' });
        }

        if (!insert) {
            props.putAreaPdu(model.area, pduList, () => {
                setPduList([]);
                setModel({ ...model, area: '' });
                document.getElementById('area').value = '';
                showMessageToastCustom(translate('general.info'), translate('sucess-to-update', 'general'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
            });

        } else if (pduList.length > 0) {
            props.addAreaPdu(pduList, () => {
                setPduList([]);
                setModel({ ...model, area: '' });
                document.getElementById('area').value = '';
                showMessageToastCustom(translate('general.info'), translate('sucess-to-update', 'general'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
            });
        } else {
            return showMessageToast({ html: translate('Informe uma area e os PDU´s'), classes: 'red' });
        }
    }

    const subtitlesPointArea = () => {
        let subtitlesItems = [];
        subtitlesItems = [...subtitlesItems, { icon: "mdi mdi-repeat", label: `${translate('pointArea.point-area', 'configuration')} - ${insert ? translate('menu.insert', 'configuration') : translate('menu.update', 'configuration')}` }];
        return subtitlesItems;
    }

    const addPdu = (value) => {
        if (!isNullOrEmpty(value)) {
            const duplicado = pduList.find(i => i.locationTarget === value);
            if (duplicado) {
                showMessageToast({ html: translate('message.invalidPdu', 'delivery'), classes: 'red' });
                return;
            }
            const area = props.areas.items.find(i => i.areaId === parseInt(model.area));
            setPduList((prevState) => ([...prevState, { areaId: area.areaId, area: area.description, locationTarget: value }]));
            document.getElementById('pdu').value = '';
            document.getElementById('pdu').focus();
        }
    }

    const deleteItem = (item) => {
        setPduList(pduList.filter(i => i.locationTarget !== item.locationTarget || i.areaId !== item.areaId));
    }

    return (
        <div>
            <Breadcrumbs id="linePickingParameters" subtitles={subtitlesPointArea()} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card">
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <div className="row" style={{ padding: '10px' }}>
                                <form>
                                    <fieldset className='fieldset'>
                                        <div className="input-field no-padding col s12">
                                            <Select
                                                id="area"
                                                name="area"
                                                valuefield="areaId"
                                                display="description"
                                                label={getVision() === VISIONS.Fiasa ? translate('line-picking:linepicking.shed') : translate('line-picking:linepicking.area')}
                                                placeHolder={translate('general:choose-one-option')}
                                                data={props.areas.items ? props.areas.items : []}
                                                defaultValue={model.area || ''}
                                                change={onChange}
                                            />
                                        </div>
                                        {
                                            !isNullOrEmpty(model.area) && <>
                                                <div className="input-field no-padding col s9">
                                                    <InputUI
                                                        id='pdu'
                                                        name='pdu'
                                                        type="text"
                                                        label={translate('delivery:fields.pdu')}
                                                        onChange={onChange}
                                                        defaultValue={''}
                                                        onKeyDown={handleFormKeyDown}
                                                    />
                                                    <ScannerCode onScanner={addPdu} />
                                                </div>
                                                <div className="col s2" style={{ paddingTop: '17px' }}>
                                                    <button
                                                        className="btn-floating btn-Small btn-principal waves-effect waves-light"
                                                        type="button"
                                                        onClick={() => addPdu(document.getElementById('pdu')?.value)}
                                                    >
                                                        <i className={`mdi mdi mdi-plus`} />
                                                    </button>
                                                </div>
                                            </>
                                        }


                                    </fieldset>
                                </form>
                            </div>
                            <div style={{ display: 'flex', flex: 1, flexWrap: 'wrap' }}>
                                {pduList?.map((i, index) => (
                                    <div key={index} style={{ display: 'flex', alignItems: 'center', padding: 4, margin: 2, border: 'solid', borderWidth: 1, width: 'auto', borderRadius: 6 }}>
                                        <i className={'mdi mdi-close-circle-outline posfix'} style={{ top: '0rem', fontSize: 20 }} onClick={() => deleteItem(i)} />
                                        <span style={{ marginLeft: 6 }}>{i.locationTarget}</span>
                                    </div>
                                ))}
                            </div>
                            {
                                pduList.length > 0 && !isNullOrEmpty(pduList[0]?.lastUpdatedOn) &&
                                <div className="row">
                                    <span style={{ marginLeft: 6 }}>{pduList[0]?.lastUpdatedBy}</span>
                                    <span style={{ marginLeft: 6 }}>{pduList[0]?.lastUpdatedOn}</span>
                                </div>
                            }
                            <div className="row">
                                <ButtonUI onClick={cancel} text={translate('cancel', 'general')} secundary="true" />
                                <ButtonUI onClick={submit} text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        area: state.linePickingReducer.area,
        equipment: state.configReducer.equipment,
        config: state.configReducer.config,
        areas: state.areaReducer.areas,
        filter: state.linePickingReducer.filter
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setAreaAdress: (areas) => {
            dispatch(LinePickingService.setArea(areas));
        },
        addAreaPdu: (data, callback) => {
            dispatch(DeliveryService.AddAreaPdu(data, callback));
        },
        putAreaPdu: (area, data, callback) => {
            dispatch(DeliveryService.PutAreaPdu(area, data, callback));
        },
        getAreaPdu: (data, callback) => {
            dispatch(DeliveryService.GetAreaPdu(data, callback));
        },
        getEquipments: (vision, filter) => {
            dispatch(ConfigurationService.getEquipments(vision, filter));
        },
        getAreas: (vision, filter, pagination) => {
            dispatch(AreaService.getAreas(vision, filter, pagination));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AreaPdu));